/**
 * Insert an item at the given index.
 * This will ensure that Vue will detect the change.
 * @param {Array} array - The array to insert the item into.
 * @param {number} index - The index to insert the item at.
 * @param {any} item - The item to insert.
 * @returns {Array} The new array.
 */
export function insertAt(array, index, item) {
  return [...array.slice(0, index), item, ...array.slice(index)];
}

/**
 * Replace an item at the given index.
 * This will ensure that Vue will detect the change.
 * @param {Array} array - The array to replace the item in.
 * @param {number} index - The index to replace the item at.
 * @param {any} item - The item to replace.
 * @returns {Array} The new array.
 */
export function replaceAt(array, index, item) {
  return [...array.slice(0, index), item, ...array.slice(index + 1)];
}

/**
 * Remove an item at the given index.
 * This will ensure that Vue will detect the change.
 * @param {Array} array - The array to remove the item from.
 * @param {number} index - The index to remove the item at.
 * @returns {Array} The new array.
 */
export function removeAt(array, index) {
  return [...array.slice(0, index), ...array.slice(index + 1)];
}
